import { withModalConditionalRender } from '@billy/design-system'
import { useCallback } from 'react'

import { ConnectBankModal } from '@features/bankAccounts/elements/ConnectBankModal'

import { ModalId } from '../../../../enums/modalId'
import { useQueryParams } from '../../../../hooks/useQueryParams'
import { DEFAULT_QUERY_PARAMS } from '../../constants/defaultQueryParams'
import { ConfirmDeleteConnectionModal } from './elements/ConfirmDeleteConnectionModal/ConfirmDeleteConnectionModal'
import { ErrorModal } from './elements/ErrorModal/ErrorModal'
import { ConnectionRenewedModal } from './elements/SuccessfulConnectionModal/ConnectionRenewedModal'

const BankConnectionRenewedModal = withModalConditionalRender(ConnectionRenewedModal)
const BankConnectionErrorModal = withModalConditionalRender(ErrorModal)
const BankConnectionDeleteConfirmationModal = withModalConditionalRender(ConfirmDeleteConnectionModal)
const BankConnectionConnectBankModal = withModalConditionalRender(ConnectBankModal)

interface BankIntegrationModalsProps {
  removeConnection: () => void
}

export const BankIntegrationModals = ({ removeConnection }: BankIntegrationModalsProps) => {
  const [, setQueryParams] = useQueryParams({
    defaultQuery: DEFAULT_QUERY_PARAMS,
    withDefaultQueryInUrl: false,
  })

  const removeQueryParams = useCallback(() => {
    setQueryParams(DEFAULT_QUERY_PARAMS)
  }, [setQueryParams])

  return (
    <>
      <BankConnectionDeleteConfirmationModal
        id={ModalId.BankConnectionRemoveConfirmationModal}
        removeConnection={removeConnection}
      />
      <BankConnectionRenewedModal id={ModalId.BankConnectionSuccessModal} />
      <BankConnectionErrorModal id={ModalId.BankConnectionErrorModal} removeQueryParams={removeQueryParams} />
      <BankConnectionConnectBankModal id={ModalId.BankConnectionAddAccountModal} />
    </>
  )
}
